module.exports = __webpack_public_path__ + "static/0089-5c88fd9ddfab59167c05e98a187e65af.png";